__turbopack_context__.v({
  "hidden": "MobileBottomNav-module-scss-module__nNwUgq__hidden",
  "icon": "MobileBottomNav-module-scss-module__nNwUgq__icon",
  "item": "MobileBottomNav-module-scss-module__nNwUgq__item",
  "itemActive": "MobileBottomNav-module-scss-module__nNwUgq__itemActive",
  "list": "MobileBottomNav-module-scss-module__nNwUgq__list",
  "menuItem": "MobileBottomNav-module-scss-module__nNwUgq__menuItem",
  "menuItemActive": "MobileBottomNav-module-scss-module__nNwUgq__menuItemActive",
  "popup": "MobileBottomNav-module-scss-module__nNwUgq__popup",
  "positioner": "MobileBottomNav-module-scss-module__nNwUgq__positioner",
  "wrapper": "MobileBottomNav-module-scss-module__nNwUgq__wrapper",
});
